'use client';

import type { FC } from 'react';
import { Skeleton } from './ui';
import { cn } from '../utils/cn';

export const ItemListItemSkeleton: FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={cn('relative w-full h-[220px] rounded-[21px] bg-white/5 overflow-hidden', className)} data-testid="item-grid-skeleton-card">
      <Skeleton className="absolute top-2 start-2 h-4 w-10" />
      <div className="absolute bottom-0 start-0 end-0 flex flex-col items-start p-3 gap-1">
        <div className="flex flex-col items-start gap-0.5 w-full">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-6 w-4/5" />
        </div>
        <Skeleton className="h-6 w-[52px] rounded-full" />
      </div>
    </div>
  );
};
